import { PackagingType } from "../../../../../api/types/generated-types";

export const packagingTypeList = Object.values(PackagingType);
